import React from 'react';

import { ResourceIdentifier } from '@cube3/common/model/resource-types';
import { Asset } from '@cube3/common/model/schema/resources/asset';

import { AttachedContractsView } from '../../../../layout/Contracts/pages/AttachedContractsView';
// UI

interface Props {
  asset: Asset;
}

export const DetailViewContracts: React.ComponentType<Props> = (props) => {
  const { asset } = props;

  return <AttachedContractsView parentResource={asset as ResourceIdentifier} />;
};
